export default [
  {
    Planid: "01",
    PlanName: "Standard",
    ListingValidity: "Listing for 3 months",
    Status: "Active",
    PlanAmount: "1500/-"
  },
  {
    Planid: "02",
    PlanName: "Pro",
    ListingValidity: "Listing for 6 months",
    Status: "Active",
    PlanAmount: "2500/-"
  }
];
